export const FormatMoney = (
  amount: number,
  removeExactZeroes: boolean = false
) => {
  let result = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);

  return removeExactZeroes ? result.replace(".00", "") : result;
};
